import template from './house-line-type.jade';
import items from '../../../enums/house-line-type';

export default angular
  .module('cian.addForm.houseLineType', ['cian.addForm.fieldTypeDropdown'])
  .directive('cianAfAboutBuildingHouseLineType', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      '$scope',
      'categoryService',
      function ($scope, categoryService) {
        this.items = items;

        $scope.$watchGroup([() => this.ad.category, () => this.ad.placementType], ([category, placementType]) => {
          if (!category) {
            return;
          }
          const { objectType } = categoryService.getInfoByCategory(category);

          this.enabled = !(objectType === 'shoppingArea' && placementType !== 'streetRetail');
        });
      },
    ],
    controllerAs: 'houseLineType',
    template,
  })).name;
